import React from 'react';
import './Lesson.scss';
import video from '../../assets/videos/video.mp4';
import { questions } from '../../assets/constants/questions'
const Lesson = () => {
    return (
        <div className="lesson">
            <div className="container-sm lesson-content">
                <div className="lesson-learn">
                    <div className="lesson-title"> <h3>1-mavzu</h3> <p>Kurs o‘qituvchisi :Mustafoyev Amir</p>
                    </div>
                    <div className="lesson-video">
                        <video controls>
                            <source src={video} type="video/mp4" />
                            <source src={video} type="video/ogg" />
                        </video>
                        <div className="video-desc">
                            <p className="desc-text">
                                Qonunlar va boshqa normativ-huquqiy hujjatlarni qo`llash masalalari bo`yocha maslahatlar berishning o`ziga xos jihatlari
                            </p>
                            <p className="views">
                                Views: <span><i className="	fas fa-eye"></i>100</span>
                            </p>
                        </div>
                    </div>
                    <div className="lesson-data">
                        <div className="lesson-docs">
                            <a href="#" download><span className="word"><i className="fas fa-file-word"></i></span>Document</a>
                            <a href="#" download><span className="ppt"><i className="	fas fa-file-powerpoint"></i></span>Presentation</a>
                            <a href="#" download><span className="word"><i className="fas fa-file-word"></i></span>Document</a>
                            <a href="#" download><span className="ppt"><i className="	fas fa-file-powerpoint"></i></span>Presentation</a>
                        </div>
                        <div className="lesson-links">
                            <p className="lesson-link-item">
                                <span> Sud qonunlari:</span>
                                <a href="#">
                                    https://www.youtube.com/watch?v=_PgWxvu9rCw
                                </a>
                            </p>
                            <p className="lesson-link-item">
                                <span> Sud qonunlari:</span>
                                <a href="#">
                                    https://www.youtube.com/watch?v=_PgWxvu9rCw
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
            <div className="lesson-questions">
                <div className="questions container-sm">
                    <h3>Nazorat savollari</h3>
                    <div className="questions-list">
                        <form className="questions-form" method="POST">
                            <div className="list">
                                {
                                    questions.map((question, index) => {
                                        return <div className="question">
                                            <div className="question-text">
                                                <span>{index+1}</span>{question.title}
                                            </div>
                                            <textarea required cols="50" rows="5" placeholder="Javob" />
                                        </div>
                                    })
                                }
                            </div>
                            <button type="submit" className="question-submit ">
                                Keyingi Mavzu
                            </button>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Lesson;
